import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Card, CardBody, Container, Input, Button, Label, Row, Col, Form, FormGroup } from 'reactstrap';
import Breadcrumbs from "../../components/Common/Breadcrumb";
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import DatePicker from 'react-datepicker';
import axios from 'axios';
import { useFormik } from 'formik';
import TableContainer from 'components/Common/TableContainer';
import * as Yup from 'yup';

import moment from 'moment';
import Spinners from 'components/Common/Spinner';
import PopupWindow from 'components/Common/PopupWindow';
import Loader from 'components/Common/Loader';
import * as XLSX from 'xlsx';  // Import the xlsx library
import { checkPermissions } from 'components/Common/ChkPermissions';
import CantAccessPage from 'components/Common/CantAccessPage';

import { useLocation, useNavigate } from 'react-router-dom';

import { getEnquiryCurrentStatusRepAPIURL } from 'BaseComponentAPI/EnquiryCurrentStatusReportAPI';

<style>
    {`
  .react-datepicker__triangle {
    left: 50%!important;
    transform: translateX(-50%);
  }
`}
</style>


const EnquiryCurrentStatusReport = () => {
    const authUser = useSelector(state => state.Login);
    document.title = "Cockpit";

    const navigate = useNavigate();

    const location = useLocation();

    const { fromDate, toDate, triggerFetch = false } = location.state || {};

    // console.log("Received From:", fromDate, "To:", toDate, "triggerFetch:", triggerFetch);

    const storedPermissions = JSON.parse(localStorage.getItem('permissions')) || {};
    const { canRead, canCreate, canChange } = checkPermissions(storedPermissions);

    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');  // Set the message from passed state
    const [popupType, setPopupType] = useState('');  // Set the type from passed state

    const [pendingData, setPendingData] = useState([]);
    const [completedData, setCompletedData] = useState([]);

    const [submittedCallType, setSubmittedCallType] = useState("");
    const [pageNo, setPageNo] = useState(1);  // Track the current page number
    const [pageSize, setPageSize] = useState(50);  // Track page size
    const [totalPages, setTotalPages] = useState('');
    const [totalItems, setTotalItems] = useState('');
    const [nextPage, setNextPage] = useState('');
    const [previousPage, setPreviousPage] = useState('');
    const [currentPage, setCurrentPage] = useState('');
    
    const customePageSize = [50, 100, 200, 300, 400]

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [loaderOption, setLoaderOption] = useState(false);
    const [disabelSaveBtn, setDisableSaveBtn] = useState(false);

    // Today's date
    const today = new Date();
    // Date 30 days ago
    const past29Days = new Date();
    past29Days.setDate(today.getDate() - 29);

    const past27Days = new Date();
    past27Days.setDate(today.getDate() - 27);

    useEffect(() => {
        if (triggerFetch) {
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, []);


    useEffect(() => {
        if (triggerFetch == true && fromDate && toDate) {
            formik.setFieldValue("startDate", moment(fromDate, "DD/MM/YYYY").toDate());
            formik.setFieldValue("endDate", moment(toDate, "DD/MM/YYYY").toDate());
            setStartDate(fromDate);
            setEndDate(toDate);   
        }
    }, [triggerFetch]);


    // Handle date change (for both startDate and endDate)
    const handleDateChange = (date, field) => {
        setPendingData([]);
        //setCompletedData([]);
        formik.setFieldValue(field, date);
    };

    const openPopup = (message, type) => {
        setPopupMessage(message);
        setPopupType(type);
        setIsPopupVisible(true);
    };

    const closePopup = () => {
        setIsPopupVisible(false);
    };

    const handlePageChange = async (newPageNo, newPageSize, startDate, endDate) => {
       // alert(newPageNo + ' param '+ newPageSize);
         if (pendingData.length != 0) {
             if (authUser.headers && Object.keys(authUser.headers).length > 0) {


                    const userUUID = authUser.headers.userUUID;
                    const startDate = moment(formik.values.startDate).format("YYYY-MM-DD");
                    const endDate = moment(formik.values.endDate).format("YYYY-MM-DD");
                    // Reset FE prefetch flag
                    fePrefetchDone = false;
                    //alert(newPageNo);
                    setPageNo(newPageNo);
                    setCurrentPage(newPageNo);
                    // 1️⃣ Fetch pending work orders AND supporting lists
                    const apiUrl =
                        `${getEnquiryCurrentStatusRepAPIURL}?userUUID=${userUUID}&fromDate=${startDate}&toDate=${endDate}&isPagination=1&pageNo=${newPageNo}&perPageRec=${newPageSize}`;

                    const activityResult = await fetchEnquiryCurrentStatusRecords(apiUrl, setPendingData, { loadSupportLists: true });

                    if (activityResult.data.length == 0) {
                        openPopup(activityResult.msg || "No data found", "warn");
                    }
                    setLoaderOption(false);
             }
         }
    };

   

    // 🔹 Fetch enquiry activity logs and auto-load 
    // fetchEnquiryActivityLogs
    const fetchEnquiryCurrentStatusRecords = async (url, setter, { loadSupportLists = false } = {}) => {
        try {
            const response = await axios.get(url, {
                headers: {
                    ...authUser.headers,
                    Authorization: `Bearer ${authUser.headers.access_token}`,
                },
            });

            const msg = response.data.responseMsg;

            if (msg == "Records not found") {
                setter([]);
                return { data: [], msg };  // ⭐ return msg also
            }

            if (msg == "Success") {
                const data = response.data.data.items || [];
                setter(data);
                //setData(response.data.data.items);
                setTotalPages(response.data.data.totalPages)
                setTotalItems(response.data.data.totalItems);
                setNextPage(response.data.data.nextPage);
                setPreviousPage(response.data.data.previousPage);
                setCurrentPage(response.data.data.currentPage); 
                setPageNo(response.data.data.currentPage);             
                
                setDisableSaveBtn(false);
                setLoaderOption(false);                
                return { data, msg };  // ⭐ return msg
            }

            return { data: [], msg };

        } catch (error) {
            console.error("Error fetching data:", error);
            return { data: [], msg: "Requested Data Not Found / 404" };
        }
    };

    let fePrefetchDone = false;
    //fetchEnquiryActivityData
    const fetchEnquiryCurrentStatusData = async (startDate, endDate, newPageNo, newPageSize) => {
        setLoaderOption(true);
        const userUUID = authUser.headers.userUUID;

        // Reset FE prefetch flag
        fePrefetchDone = false;
        
        // 1️⃣ Fetch pending work orders AND supporting lists
        const apiUrl =
            `${getEnquiryCurrentStatusRepAPIURL}?userUUID=${userUUID}&fromDate=${startDate}&toDate=${endDate}&isPagination=1&pageNo=${newPageNo}&perPageRec=${newPageSize}`;

        const activityResult = await fetchEnquiryCurrentStatusRecords(apiUrl, setPendingData, { loadSupportLists: true });

        if (activityResult.data.length == 0) {
            openPopup(activityResult.msg || "No data found", "warn");
        }

        setLoaderOption(false);
    };
    

    const formik = useFormik({
        initialValues: {
            startDate: new Date(),
            endDate: new Date(),
        },
        validationSchema: Yup.object({
            startDate: Yup.date()
                .required('Start Date is required'),

            endDate: Yup.date()
                .required('End Date is required')
                .test(
                    "date-range",
                    "End Date should not be before Start Date and not more than 3 days later",
                    function (value) {
                        const { startDate } = this.parent;
                        if (startDate && value) {
                            const diff = moment(value).diff(moment(startDate), "days");

                            // ✅ allow same day (0) up to 3 days later
                            return diff >= 0 && diff <=3 ;
                        }
                        return true;
                    }
                ),
        }),

        onSubmit: async (values) => {
            setLoaderOption(true);
            setDisableSaveBtn(true);
            setPendingData([]);
            //setCompletedData([]);
            setPageSize(50);
            if (!authUser.headers || Object.keys(authUser.headers).length == 0) return;

            //const startDate = moment(values.startDate).format("DD/MM/YYYY");
            //const endDate = moment(values.endDate).format("DD/MM/YYYY");


            const startDate = moment(values.startDate).format("YYYY-MM-DD");
            const endDate = moment(values.endDate).format("YYYY-MM-DD");
            // 🔹 Step 1: Fetch work orders first
            
            await fetchEnquiryCurrentStatusData(startDate, endDate, pageNo, pageSize);
            setDisableSaveBtn(false);
            setLoaderOption(false);
        }


    });

    const pendingColumns = useMemo(
        () => [
            {
                header: "Sr.",
                accessorKey: "sequenceNo",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "Enq. Id",
                accessorKey: "enquiryId",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "Enq. Date",
                accessorKey: "enquiryDate",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "Activty Datetime",
                accessorKey: "activityDatetime",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "Activity",
                accessorKey: "activity",
                enableColumnFilter: true,
                enableSorting: true,
            },            
            {
                header: "Ori.Header",
                accessorKey: "originatedHeader",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "Enq.Header",
                accessorKey: "enquiryHeader",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "Cust.Mobile",
                accessorKey: "customerMobile",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "Customer Name",
                accessorKey: "customerName",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "Handeled By",
                accessorKey: "processedByName",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "Last Followup",
                accessorKey: "lastFollowupDateTime",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "Future Followup",
                accessorKey: "futureFollowupDateTime",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "Reason",
                accessorKey: "reasonText",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "Remark",
                accessorKey: "reasonRemark",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "WO Serial",
                accessorKey: "woSerialNo",
                enableColumnFilter: true,
                enableSorting: true,
            },

            {
                header: "WO Booked At",
                accessorKey: "woBookedDateTime",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "WO Booked By",
                accessorKey: "woBookedByName",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "WO Execution At",
                accessorKey: "woExeDateTime",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "WO Amt",
                accessorKey: "woFinalAmount",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "Products",
                accessorKey: "productNames",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "Product Prices",
                accessorKey: "productPrices",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "Ops Executive",
                accessorKey: "operationExecutiveName",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "Field Executive",
                accessorKey: "fieldExecutiveName",
                enableColumnFilter: true,
                enableSorting: true,
            },
        ],[]       
    );
  

    const exportToExcel = async () => {
        setLoaderOption(true);
        if (authUser.headers && Object.keys(authUser.headers).length > 0 && pendingData.length != 0) {
            // console.log( `${getNewCurrentCallBoardStatusAPIURL}?userUUID=${authUser.headers.userUUID}&callType=${formik.values.callType}&isPagination=0&pageNo=0&perPageRec=0`)
            try {

                const startDate = moment(formik.values.startDate).format("YYYY-MM-DD");
                const endDate = moment(formik.values.endDate).format("YYYY-MM-DD");
                const response = await axios.get(
                    //`${getHistoricalCallBoardsRecordsAPIURL}?userUUID=${authUser.headers.userUUID}&callType=${formik.values.callType}&isPagination=0&pageNo=0&perPageRec=0&historicDate=${formik.values.selectedDate}`,
                     `${getEnquiryCurrentStatusRepAPIURL}?userUUID=${authUser.headers.userUUID}&fromDate=${startDate}&toDate=${endDate}&isPagination=0&pageNo=0&perPageRec=0`,
                    {
                        headers: { ...authUser.headers },
                        'Authorization': `Bearer ${authUser.headers.access_token}`
                    }
                );

                if (response.data.responseCode == 0) {
                    const rawData = response.data.data.items; // API response data

                    // Exclude "Action" column
                    const filteredColumns = pendingColumns.filter(col => col.header != "Action");

                    // Define headers for Excel
                    const columnHeaders = filteredColumns.map(col => col.header);

                    // Map and transform data based on column definitions
                    const formattedData = rawData.map(item =>
                        filteredColumns.map(col => {
                            const value = item[col.accessorKey] ?? "";

                            // Apply column-specific formatting
                            switch (col.accessorKey) {
                                case "callStatus":
                                    return value == 1 ? "Attended" : "Unattended";
                                default:
                                    return value;
                            }
                        })
                    );

                    // Combine headers and data
                    const sheetData = [columnHeaders, ...formattedData];

                    // Create worksheet and workbook
                    const ws = XLSX.utils.aoa_to_sheet(sheetData);
                    const wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, `${startDate}-To-${endDate}`);

                    // Get the current date and time in IST
                    const currentDate = new Date().toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });
                    const formattedDate = currentDate.replace(",", "").replace(/\//g, "-").replace(/:/g, "-").split(" ")[0] + " " + currentDate.split(" ")[1];

                    // Set the file name dynamically
                    const fileInitialName= 'Enquiry_Current_Status';
                    const fileName = `${fileInitialName}-${startDate}-${endDate}.xlsx`;

                    // Export the Excel file
                    XLSX.writeFile(wb, fileName);

                    setLoaderOption(false);
                } else {
                    console.error("API Response Error:", response.data.responseMsg);
                    setLoaderOption(false);
                    openPopup(response.data.responseMsg, "error");
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                setLoaderOption(false);
                openPopup("Requested Data Not Found / 404", 'warn')
            }
        }
    };

    if (!canRead) {
        return (
            <>
                <React.Fragment>
                    <div className="page-content">
                        <Container fluid>
                            <Breadcrumbs title="Reports" breadcrumbItem="Enquiry Current Status" />
                            <CantAccessPage />
                        </Container>
                    </div>
                </React.Fragment>
            </>
        )
    }
    else {
        if (loaderOption == true) {
            return (
                <>
                    <Loader />
                </>
            )
        }
        else {
            return (
                <React.Fragment>
                    <div className="page-content">
                        <Container fluid>
                            <Breadcrumbs title="Reports" breadcrumbItem="Enquiry Current Status" />
                            <Card>
                                <CardBody className="border-bottom">
                                    <div style={{ padding: '20px' }}>

                                        <Form onSubmit={formik.handleSubmit}>

                                            <Row className='my-3'>
                                                {/* From Date Picker */}
                                                <Col md="4">
                                                    <FormGroup>
                                                        <Label for="startDate">Start Date</Label>

                                                        <DatePicker
                                                            selected={formik.values.startDate}
                                                            onChange={(date) => {
                                                                handleDateChange(date, "startDate");
                                                                formik.setFieldValue("endDate", null);  // ⭐ MUST BE NULL
                                                            }}
                                                            minDate={past29Days}   // ❌ Disable dates before 30 days
                                                            maxDate={today}  
                                                            dateFormat="dd/MM/yyyy"
                                                            className="form-control"
                                                            placeholderText="Select Start Date"
                                                            popperPlacement="bottom"
                                                            portalId="root"
                                                            renderCustomHeader={({ date, decreaseMonth, increaseMonth }) => (
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        alignItems: "center",
                                                                        padding: "8px 12px",
                                                                        borderBottom: "1px solid #eee",
                                                                        background: "#fff",

                                                                    }}
                                                                >
                                                                    <button
                                                                        onClick={decreaseMonth}
                                                                        type="button"
                                                                        style={{
                                                                            border: "none",
                                                                            background: "transparent",
                                                                            fontSize: "18px",
                                                                            cursor: "pointer",
                                                                        }}
                                                                    >
                                                                        ◀
                                                                    </button>

                                                                    <span style={{ fontSize: "16px", fontWeight: "600" }}>
                                                                        {date.toLocaleDateString("en-US", {
                                                                            month: "long",
                                                                            year: "numeric",
                                                                        })}
                                                                    </span>

                                                                    <button
                                                                        onClick={increaseMonth}
                                                                        type="button"
                                                                        style={{
                                                                            border: "none",
                                                                            background: "transparent",
                                                                            fontSize: "18px",
                                                                            cursor: "pointer",
                                                                        }}
                                                                    >
                                                                        ▶
                                                                    </button>
                                                                </div>
                                                            )}
                                                        />


                                                        {formik.touched.startDate && formik.errors.startDate && (
                                                            <div style={{ color: "red", marginTop: "5px" }}>
                                                                {formik.errors.startDate}
                                                            </div>
                                                        )}
                                                    </FormGroup>
                                                </Col>


                                                {/* To Date Picker */}
                                                <Col md="4">
                                                    <FormGroup>
                                                        <Label for="endDate">End Date</Label>
                                                        <DatePicker
                                                            selected={formik.values.endDate}
                                                            onChange={(date) => handleDateChange(date, 'endDate')}
                                                            //minDate={past27Days}   // ❌ Disable dates before 30 days
                                                            //maxDate={today} 
                                                            minDate={moment(formik.values.startDate).add(0, "days").toDate()}
                                                            maxDate={moment.min(
                                                                    moment(formik.values.startDate).add(2, "days"),
                                                                    moment()
                                                                ).toDate()
                                                            }
                                                            dateFormat="dd/MM/yyyy"
                                                            className="form-control"
                                                            placeholderText="Select End Date"
                                                            popperPlacement="bottom"
                                                            portalId="root"
                                                            renderCustomHeader={({ date, decreaseMonth, increaseMonth }) => (
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        alignItems: "center",
                                                                        padding: "8px 12px",
                                                                        borderBottom: "1px solid #eee",
                                                                        background: "#fff",
                                                                    }}
                                                                >
                                                                    <button
                                                                        onClick={decreaseMonth}
                                                                        type="button"
                                                                        style={{
                                                                            border: "none",
                                                                            background: "transparent",
                                                                            fontSize: "18px",
                                                                            cursor: "pointer",
                                                                        }}
                                                                    >
                                                                        ◀
                                                                    </button>

                                                                    <span style={{ fontSize: "16px", fontWeight: "600" }}>
                                                                        {date.toLocaleDateString("en-US", {
                                                                            month: "long",
                                                                            year: "numeric",
                                                                        })}
                                                                    </span>

                                                                    <button
                                                                        onClick={increaseMonth}
                                                                        type="button"
                                                                        style={{
                                                                            border: "none",
                                                                            background: "transparent",
                                                                            fontSize: "18px",
                                                                            cursor: "pointer",
                                                                        }}
                                                                    >
                                                                        ▶
                                                                    </button>
                                                                </div>
                                                            )}
                                                        />
                                                        {formik.touched.endDate && formik.errors.endDate && (
                                                            <div style={{ color: 'red', marginTop: '5px' }}>
                                                                {formik.errors.endDate}
                                                            </div>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                            </Row>

                                            {/* <Row className="mt-3">
                                                
                                                <Col md="12">
                                                    <Button color="primary" type="submit" disabled={disabelSaveBtn || !canRead}>
                                                        Submit
                                                    </Button>
                                                </Col>
                                            </Row> */}

                                            <Row className="mt-3 align-items-center">
                                                {/* Submit Button */}
                                                <Col md="6">
                                                    <Button
                                                        color="primary"
                                                        type="submit"
                                                        disabled={disabelSaveBtn || !canRead}
                                                    >
                                                        Submit
                                                    </Button>
                                                </Col>

                                                {/* Export Button */}
                                                <Col md="6" className="text-end">
                                                    {pendingData.length !== 0 && (
                                                        <Button
                                                            color="success"
                                                            type="button"
                                                            onClick={exportToExcel}
                                                        >
                                                            Export Excel
                                                        </Button>
                                                    )}
                                                </Col>
                                            </Row>
                                        </Form>
                                    </div>

                                    {
                                        pendingData.length != 0
                                            ?
                                            <div className='mt-3'>
                                                {/* { <div className="d-flex align-items-center justify-content-end mb-2">
                                                    <div className="flex-shrink-0">
                                                        <button
                                                            onClick={exportToExcel}  // Trigger the export function
                                                            className="btn btn-primary me-1"
                                                        >
                                                            Export Excel
                                                        </button>
                                                    </div>
                                                </div> } */}
                                                <h5 className="card-title mb-3" style={{ color: '#b72323' }}>
                                                   Enquiry Current Status From {" "}
                                                    {formik.values.startDate
                                                        ? moment(formik.values.startDate).format("DD MMM YYYY")
                                                        : "—"}{" "}
                                                    To{" "}
                                                    {formik.values.endDate
                                                        ? moment(formik.values.endDate).format("DD MMM YYYY")
                                                        : "—"}

                                                </h5>

                                                
                                                <TableContainer
                                                    columns={pendingColumns}
                                                    data={pendingData || []}
                                                    isGlobalFilter={true}
                                                    isPagination={true}
                                                    SearchPlaceholder="Search..."
                                                    isCustomPageSize={true}
                                                    tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                                                    theadClass="table-light"
                                                    paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                                    pagination="pagination"
                                                    getRowProps={row => ({
                                                        className: "",
                                                    })}
                                                    onPageChange={handlePageChange} // Pass page change handler
                                                    onPageSizeChange={handlePageChange} // Pass page size change handler
                                                    pageSize={pageSize}
                                                    setPageSize={setPageSize}
                                                    totalPages={totalPages}
                                                    totalItems={totalItems}
                                                    tableNextPage={nextPage}
                                                    tablePreviousPage={previousPage}
                                                    tableCurrentPage={currentPage}
                                                    customePageSize={customePageSize}

                                                />
                                            </div>
                                            :
                                            ''
                                    }

                                    {/*
                                        completedData.length != 0
                                            ?
                                            <div className='mt-3'>
                                                {}
                                                <h5 className="card-title mb-3" style={{ color: '#b72323' }}>
                                                    Completed Work Orders

                                                    
                                                </h5>
                                                <TableContainer
                                                    columns={completedColumns}
                                                    data={completedData || []}
                                                    isGlobalFilter={true}
                                                    isPagination={true}
                                                    SearchPlaceholder="Search..."
                                                    isCustomPageSize={true}
                                                    tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                                                    theadClass="table-light"
                                                    paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                                    pagination="pagination"
                                                    getRowProps={row => ({
                                                        className: "",
                                                    })}
                                                    onPageChange={handlePageChange} // Pass page change handler
                                                    onPageSizeChange={handlePageChange} // Pass page size change handler
                                                    pageSize={pageSize}
                                                    setPageSize={setPageSize}
                                                    totalPages={totalPages}
                                                    totalItems={totalItems}
                                                    tableNextPage={nextPage}
                                                    tablePreviousPage={previousPage}
                                                    tableCurrentPage={currentPage}
                                                    customePageSize={customePageSize}

                                                />
                                            </div>
                                            :
                                            ''
                                    */}
                                </CardBody>
                            </Card>
                        </Container>
                    </div>

                    {isPopupVisible && (
                        <PopupWindow message={popupMessage} type={popupType} onClose={closePopup} />
                    )}
                </React.Fragment>
            );
        }
    }
}

EnquiryCurrentStatusReport.propTypes = {
    t: PropTypes.any,
};

export default withTranslation()(EnquiryCurrentStatusReport);